import { createStyles } from 'antd-style'

export const useStyles = createStyles(() => ({
  progress: {
    borderRadius: 10,
    maxWidth: 67,
    width: '100%',
    height: 10
  }
}))
